import { render, staticRenderFns } from "./edit-combinationstock.vue?vue&type=template&id=5132f0ba&"
import script from "./edit-combinationstock.vue?vue&type=script&lang=ts&"
export * from "./edit-combinationstock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports